import React from 'react';
import { AuthorWrapper, AuthorList, AuthorItem, AuthorLink, AuthorImage, AuthorName, Prefix } from './styles.Authors';
import { Author } from '../../../config/models';
import { mainConfig } from '../../../config/config.provider';
import { AuthorMap } from '../../../config/authorsMap';

interface TagProps {
    prefix?: string;
    elements?: Author[];
}

const fallbackAuthorImg = 'https://img.br.de/0dac46ea-dcb0-413b-9b1e-44a44bbf6524.png?q=100';
const fallbackAuthorLink = 'https://www.br.de/nachrichten/autoren/br24-redaktion,18ebe837-9062-482c-9217-50ce772a3377';

export const Authors: React.FC<TagProps> = ({ elements, prefix = 'Von' }) => {
    const authors = elements || mainConfig.authors;

    return (
        <AuthorWrapper>
            {prefix && <Prefix>{prefix}</Prefix>}
            <AuthorList>
                {authors.map((author, index) => (
                    <AuthorItem key={`author-${index}`}>
                        <AuthorLink
                            href={AuthorMap[author].link || fallbackAuthorLink}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <AuthorImage src={AuthorMap[author].img || fallbackAuthorImg} />
                            <AuthorName>{author}</AuthorName>
                        </AuthorLink>
                    </AuthorItem>
                ))}
            </AuthorList>
        </AuthorWrapper>
    );
};
